import React,{ Component } from "react";
import PropTypes from 'prop-types';
//material-ui design helpers
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
//material-ui core components
import { Typography } from "@mui/material";
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
// import DragIcon from '@mui/icons-material/DragHandle';
// import DragOffIcon from '@mui/icons-material/ExploreOff';
// import DragOnIcon from '@mui/icons-material/Explore';

const styles = (theme:Theme):any => ({
  flex: {
    flex: 1,
  },
  // closable: {
  //   //color: 'inherit'
  // },
  // hide: {
  //   display:'none',
  // },
  // show: {
  //   display:'block',
  // }
});

class ClosableBar extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  render(){
    const { children, classes, onClose } = this.props;
    //const { children, classes, onClose, drag, onDrag } = this.props;
    //const dragmode = (typeof onDrag === 'function');
    return(
      <Toolbar>
        <Typography variant="h6" color="inherit" className={classes.flex}>
          {children}
        </Typography>
        {/* {dragmode&&
        <IconButton color="inherit" onClick={onDrag} aria-label="Drag">
          {(drag?<DragOnIcon />:<DragOffIcon />)}
        </IconButton>
        } */}
        <IconButton color="inherit" onClick={onClose} aria-label="Close">  {/*className={classes.closable} className={(dragmode&&drag)?classes.hide:classes.show}*/}
          <CloseIcon />
        </IconButton>
      </Toolbar>
    )
  }
}

ClosableBar.propTypes = {
  onClose: PropTypes.func,
}

//ClosableBar = withStyles(styles, { withTheme: true })(ClosableBar);
export default withStyles(styles, { withTheme: true })(ClosableBar);



